import { FC } from "react"
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  useTheme,
  CardProps,
} from "@mui/material"
import { Image } from "components/Image"

interface IMovieCardProps extends CardProps {
  poster?: string
  title?: string
  genre?: string
  duration?: string
}

export const MovieCard: FC<IMovieCardProps> = ({
  poster,
  title,
  genre,
  duration,
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`MovieShowTimesCard`]?.styleOverrides || {}
  const {
    root,
    cardMedia,
    cardContent,
    movieTitle,
    movieGenre,
    movieDuration,
    infoContainer,
  } = styleOverrides
  return (
    <Card sx={root} {...props}>
      <CardMedia>
        <Image src={poster} sx={cardMedia} />
      </CardMedia>
      <CardContent sx={cardContent}>
        <Typography variant="h1" sx={movieTitle}>
          {title}
        </Typography>
        <Box sx={infoContainer}>
          <Typography variant="body1" sx={movieGenre}>
            {genre}
          </Typography>
          <Typography variant="body1" sx={movieDuration}>
            {duration}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  )
}
